import React from "react";
import {Button} from "antd";
import dayjs from "dayjs";

import {isWithinGracePeriod} from "../../helpers/booking";
import confirmAction from '../../helpers/confirmAction';
import {messageType, showMessages} from "../../helpers/message";
import {useAppSelector} from '../../hooks/useStore';
import {useCancelBookingMutation} from "../../store/api/bookingsApi";
import {selectIsStaff} from "../../store/slices/userSlice";
import {BaseError} from "../../types/apiTypes";
import {BookingCancelParams} from "../../types/bookingTypes";

const BookingCancel = ({bookingID, bookingStartTime, bookingCreateTime, hideBookingCancel, onCancelBooking}: BookingCancelParams ) => {
    const isStaff = useAppSelector(selectIsStaff);
    const [cancelBooking, {isSuccess, isError, error, isLoading}] = useCancelBookingMutation();

    React.useEffect(() => {
        if (isSuccess) {
            showMessages('Booking has been cancelled.', messageType.success);
        }
        if (isError) {
            showMessages((error as BaseError).data?.message, messageType.error);
        }
    }, [error, isError, isSuccess]);

    const handleClick = async () => {
        const now = dayjs().tz();
        const startedAt = dayjs(bookingStartTime).tz();
        const createdAt = dayjs(bookingCreateTime).tz();

        // Check if now is after booking start time and outside the grace period, if so
        // hide the cancel booking button and display error message.
        if (!isStaff && !isWithinGracePeriod(createdAt) && now.isAfter(startedAt)) {
            showMessages('Cannot cancel booking that has started. Please end booking instead.', messageType.error);
            hideBookingCancel();
            return;
        }

        try {
            await cancelBooking(bookingID);
            onCancelBooking();
        } catch (error: any) {
            showMessages(error.message, messageType.error);
        }
    };

    return (
        <Button
            danger
            htmlType='button'
            loading={isLoading}
            onClick={() => {
                confirmAction(
                    'Cancel Booking?',
                    'Are you sure you want to cancel this booking?',
                    handleClick);
            }}
        >
            Cancel Booking
        </Button>
    );
}

export default BookingCancel;
